import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [initialCheckDone, setInitialCheckDone] = useState(false);

    const checkAuth = useCallback(async () => {
        if (!initialCheckDone) {
            setLoading(true);
        }
        try {
            const response = await axios.get(`http://34.47.145.31:8000/api/auth/check`, {
                withCredentials: true,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache'
                }
            });

            if (response.data.isAuthenticated) {
                setIsAuthenticated(true);
                setUser(response.data.user);
            } else {
                setIsAuthenticated(false);
                setUser(null);
            }
        } catch (error) {
            console.error('Auth check error:', error);
            setIsAuthenticated(false);
            setUser(null);
        } finally {
            setLoading(false);
            setInitialCheckDone(true);
        }
    }, [initialCheckDone]);

    const login = async (credentials) => {
        setLoading(true);
        try {
            const response = await axios.post(
                `http://34.47.145.31:8000/api/auth/login`,
                credentials,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.success) {
                await checkAuth();
                return { success: true };
            } else {
                return {
                    success: false,
                    error: response.data.message || 'Login failed'
                };
            }
        } catch (error) {
            console.error('Login error:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Login failed'
            };
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        try {
            await axios.post(`http://34.47.145.31:8000/api/auth/logout`, {}, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            setUser(null);
            return true;
        } catch (error) {
            console.error('Logout error:', error);
            return false;
        }
    };

    const updateProfile = async (formData) => {
        try {
            const response = await axios.put(
                `http://34.47.145.31:8000/api/profile`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            if (response.data) {
                setUser(response.data);
                return { success: true };
            }
            return { success: false };
        } catch (error) {
            console.error('Profile update error:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Update failed'
            };
        }
    };

    const value = {
        isAuthenticated,
        user,
        loading,
        login,
        logout,
        updateProfile,
        checkAuth,
        initialCheckDone
    };

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === null) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
